export const WELCOME_MESSAGE = [
  'Push notifications allow you to communicate with your users, even when they aren’t viewing your app.\n',
  'Get started by adding a new notification, or importing notification you’ve made in another environment.'
];
